var React = require('react');

function BlogSearchClose (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13.6 15.109L0 1.409 1.4 0 15 13.7z","fillRule":"evenodd","key":0}),React.createElement("path",{"d":"M1.4 15.109L15 1.409 13.6 0 0 13.7z","fillRule":"evenodd","key":1})]);
}

BlogSearchClose.defaultProps = {"className":"close-icon","viewBox":"0 0 15 15.109","aria-hidden":"true"};

module.exports = BlogSearchClose;

BlogSearchClose.default = BlogSearchClose;
